import { createSerializeWire } from './Serializable';
export class WitnessModel {
    constructor({ invocation, verification }) {
        this.serializeWire = createSerializeWire(this.serializeWireBase.bind(this));
        this.invocation = invocation;
        this.verification = verification;
    }
    serializeWireBase(writer) {
        writer.writeVarBytesLE(this.invocation);
        writer.writeVarBytesLE(this.verification);
    }
}

//# sourceMappingURL=WitnessModel.js.map
